<template>
    <div class="col-lg-12">
        <div class="card stretch stretch-full">
            <div class="card-header">
                <h5 class="card-title">İlaç Hareketleri Listesi</h5>
                <div class="card-header-action">
                    <div class="card-header-btn">
                        <div data-bs-toggle="tooltip" title="Yenile">
                            <button @click="fetchData()" class="avatar-text avatar-xs bg-warning"
                                data-bs-toggle="refresh"> </button>
                        </div>
                        <div data-bs-toggle="tooltip" title="Ekranı Kapla/Küçült">
                            <a href="javascript:void(0);" class="avatar-text avatar-xs bg-success"
                                data-bs-toggle="expand"> </a>
                        </div>
                    </div>
                    <div class="dropdown">
                        <a href="javascript:void(0);" class="avatar-text avatar-sm" data-bs-toggle="dropdown"
                            data-bs-offset="25, 25">
                            <div data-bs-toggle="tooltip" title="Seçenekler">
                                <i class="feather-more-vertical"></i>
                            </div>
                        </a>
                        <div class="dropdown-menu dropdown-menu-end">
                            <router-link to="/medicine/input" class="dropdown-item"><i
                                    class="feather-plus-circle"></i>Yeni
                                Ekle</router-link>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card-body custom-card-action p-0">
                <div class="table-responsive">
                    <table class="table table-hover mb-0">
                        <thead>
                            <tr>
                                <th scope="col">Tarih</th>
                                <th scope="col">Numarası</th>
                                <th scope="col">Etiket</th>
                                <th scope="col">Nereden</th>
                                <th scope="col">Nereye</th>
                                <th scope="col" class="text-end">İşlemler</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(medicineTransaction, index) in medicineTransactions"
                                :key="medicineTransaction.id">
                                <td>
                                    <div class="hstack gap-3">
                                        <div class="avatar-text bg-soft-primary text-primary">
                                            <i class="feather-book-open"></i>
                                        </div>
                                        <div>
                                            <router-link
                                                :to="{ name: 'MedicineEdit', params: { id: medicineTransaction.id } }"
                                                class="d-block mb-1">{{ formatDate(medicineTransaction.date)
                                                }}</router-link>
                                        </div>
                                    </div>
                                </td>
                                <td>{{ medicineTransaction.transaction_id }}</td>
                                <td>{{ medicineTransaction.transaction_label }}</td>
                                <td>{{ medicineTransaction.from_object_name }} [{{ medicineTransaction.from_where_name
                                    }}]</td>
                                <td>{{ medicineTransaction.to_object_name }} [{{ medicineTransaction.to_where_name }}]
                                </td>
                                <td>
                                    <div class="hstack gap-2 justify-content-end">
                                        <i class="feather-eye cursor-pointer fs-16" @click="toggleDetails(index)"></i>
                                        <a href="#" @click="deleteMedicineTransaction(medicineTransaction.id)"
                                            class="avatar-text avatar-md bg-red">
                                            <i class="feather-delete fs-16"></i>
                                        </a>

                                    </div>
                                </td>
                            </tr>
                            <tr v-if="expandedRow === index">
                                <td colspan="6">
                                    <div class="detail-box">
                                        <p><strong>Detay Bilgisi:</strong> deneme</p>
                                        <p><strong>Ekstra Not:</strong> deneme</p>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="card-footer">
                <Pagination :currentPage="currentPage" :totalPages="totalPages" :next="next" :previous="previous"
                    @page-changed="fetchData" />
            </div>
        </div>
    </div>
</template>

<script>
import dayjs from 'dayjs';
import Swal from 'sweetalert2';
import Pagination from '@/components/common/Pagination.vue';


export default {
    name: 'MedicineTable',
    components: {
        Pagination
    },
    data() {
        return {
            medicineTransactions: [],
            expandedRow: null,
            currentPage: 1,
            totalPages: 1,
            next: true,
            previous: false
        }
    },
    async mounted() {
        const page = Number(this.$route.params.page) || 1;
        await this.fetchData(page);
    },
    watch: {
        '$route.params.page'(newPage) {
            this.fetchData(Number(newPage));
        }
    },
    methods: {
        async fetchData(page = 1) {
            console.log('fetch medicines called');
            try {
                const response = await this.$axios.get(`medicine_transaction_v/?page=${page}`);
                console.log('response:', response.data);
                this.medicineTransactions = response.data.results;
                this.totalPages = Math.ceil(response.data.count / 10);
                this.currentPage = page;
                this.next = response.data.next;
                this.previous = response.data.previous;
            } catch (error) {
                Swal.fire('Hata!', `${error}`, 'error');
            }
        },
        async deleteMedicineTransaction(id) {
            const result = await Swal.fire({
                title: "Silmek istediğinizden emin misiniz?",
                text: "Bu işlem geri alınamaz!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonText: "Evet, sil!",
                cancelButtonText: "Hayır, iptal et"
            });

            if (result.isConfirmed) {
                try {
                    await this.$axios.delete(`medicine_transaction/${id}/`);
                    Swal.fire("Başarılı!", "Kayıt silindi.", "success");

                    this.fetchData();
                } catch (err) {
                    Swal.fire("Hata!", "Silme işlemi başarısız.", "error");
                    console.error(err);
                }
            }
        },
        toggleDetails(index) {
            console.log(index);
            this.expandedRow = this.expandedRow === index ? null : index;
        },
        formatDate(date) {
            if (!date) {
                return '';
            }
            return dayjs(date).format('DD.MM.YYYY');
        }
    }
}
</script>
<style scoped>
.detail-box {
    padding: 10px;
    background-color: #f9f9f9;
    border: 1px solid #ddd;
    border-radius: 5px;
}

.cursor-pointer {
    cursor: pointer;
}
</style>